import {
    ON_START_DELETE_LOBBY_FLODE,ON_DELETE_LOBBY_FLODE,ON_ERROR_DELETE_LOBBY_FLODE,
    ON_START_FETCH_FOLDE,
    ON_FETCH_FOLDE,
    ON_ERROR_FETCH_FOLDE,
    ON_START_NEW_FLODE,
    ON_NEW_FLODE,
    ON_ERROR_NEW_FLODE,
    ON_START_FETCH_TODOLIST,
    ON_FETCH_TODOLIST,
    ON_ERROR_FETCH_TODOLIST,
    SET_ZERO_INTRANET
} from "../constants/ActionTypes";
import { translate } from "../util/intlHelper";

const INIT_STATE = {
    Folde:[],
    AttgoraList:[],
    message:"",
    isloading:true,
}


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SET_ZERO_INTRANET:{
            return INIT_STATE;
          }
        case ON_START_FETCH_FOLDE:{
            console.log("ON_START_FETCH_FOLDE",action)
            return {
                ...state,
                message:"",
                isloading:true
            }
        }
        case ON_FETCH_FOLDE:{
            console.log("ON_FETCH_FOLDE",action)
            return {
                ...state,
                Folde:action.payload.Flode,
                message:"",
                isloading:false
            }
        }
        case ON_ERROR_FETCH_FOLDE:{
            console.log("ON_ERROR_FETCH_FOLDE",action)
            return {
                ...state,
                message:translate("Error.Lobby.posts.fetching"),
                isloading:false
            }
        }
        case ON_START_NEW_FLODE:{
            console.log("ON_START_NEW_FLODE",action)
            return {
                ...state,
                message:"",
                isloading:true
            }
        }
        case ON_NEW_FLODE:{
            console.log("ON_NEW_FLODE",action)
            return {
                ...state,
                Folde:action.payload.Flode,
                message:translate("Action.Lobby.post.create"),
                isloading:false
            }
        }
        case ON_ERROR_NEW_FLODE:{
            console.log("ON_ERROR_NEW_FLODE",action)
            return {
                ...state,
                message:translate("Error.Lobby.post.create"),
                isloading:false
            }
        }
        case ON_START_FETCH_TODOLIST:{
            console.log("ON_START_FETCH_TODOLIST",action)
            return {
                ...state,
                message:""
            }
        }
        case ON_FETCH_TODOLIST:{
            console.log("ON_FETCH_TODOLIST",action)
            return {
                ...state,
                AttgoraList:action.payload.AttgoraList,
                message:translate("Action.Lobby.todo.fetch"),
                isloading:false
            }
        }
        case ON_ERROR_FETCH_TODOLIST:{
            console.log("ON_ERROR_FETCH_TODOLIST",action)
            return {
                ...state,
                message:translate("Error.Lobby.todo.fetch"),
                isloading:false
            }
        }
        // ON_START_DELETE_LOBBY_FLODE,ON_DELETE_LOBBY_FLODE,ON_ERROR_DELETE_LOBBY_FLODE,
        case ON_START_DELETE_LOBBY_FLODE:{
            console.log("ON_START_DELETE_LOBBY_FLODE",action)
            return {
                ...state,
                message:"",
                isloading:true
            }
        }
        case ON_DELETE_LOBBY_FLODE:{
            console.log("ON_DELETE_LOBBY_FLODE",action)
            return {
                ...state,
                message:"",
                isloading:false
            }
        }
        case ON_ERROR_DELETE_LOBBY_FLODE:{
            console.log("ON_ERROR_DELETE_LOBBY_FLODE",action)
            return {
                ...state,
                message:translate("Error.Lobby.post.delete"),
                isloading:false
            }
        }
        default: return state;
    }
}

